import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FieldDashboardDataService } from '../field-dashboard-data.service';

@Component({
  selector: 'app-field-analysis',
  templateUrl: './field-analysis.component.html',
  styleUrls: ['./field-analysis.component.css'],
  standalone: false
})
export class FieldAnalysisComponent implements OnInit {
  fieldId: string;
  farmId: string;
  farmName: string = '';
  fieldName: string = '';
  crop: string = '';
  cultivar: string = '';
  seasonYear: string = '';
  fieldInfoLoading: boolean = true;

  constructor(
    private router: Router,
    private dataService: FieldDashboardDataService
  ) { }

  ngOnInit(): void {
    const now = new Date();
    const year = now.getMonth() >= 5 ? now.getFullYear() + 1 : now.getFullYear();
    this.seasonYear = `${year - 1}/${year}`;

    this.dataService.fieldData$.subscribe(data => {
      this.fieldId = data.fieldId;
      this.farmId = data.farmId;
      this.fieldName = data.fieldName;
      this.farmName = data.farmName || '';
      this.crop = data.crop || '';
      this.cultivar = data.cultivar || '';
      if (data.crop || data.cultivar) {
        this.fieldInfoLoading = false;
      }
      if (data.fieldInfoLoading !== undefined) {
        this.fieldInfoLoading = data.fieldInfoLoading;
      }
      if (data.season) {
        this.seasonYear = data.season;
      }
    });
  }

  navigateToFieldAnalysis(): void {
    this.router.navigate(['/field'], {
      state: {
        id: this.fieldId,
        farmId: this.farmId,
        farmName: this.farmName,
        fieldName: this.fieldName,
        analysisTypes: '',
        analysisDates: ''
      }
    });
  }
}
